// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1R38O","dragIcon":"SortableItem_dragIcon__1mUq4","disabled":"SortableItem_disabled__2YEAd"};